<div class="h-screen w-screen flex overflow-hidden bg-glico-fundo">
  <template-sidebar [aberto]="menuAberto" (fechar)="menuAberto = false"></template-sidebar>

  <div class="flex-1 flex flex-col min-w-0">
    <template-navbar (alternarMenu)="menuAberto = !menuAberto"></template-navbar>

    <main class="glico-conteudo flex-1 overflow-auto px-4 sm:px-6 lg:px-8 py-8">
      <router-outlet />
    </main>

    <footer class="flex items-center justify-center gap-2 py-2 border-t border-gray-100 bg-white">
      <span class="text-xs text-gray-400 font-semibold">Glicosus</span>
    </footer>
  </div>
</div>
